import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { HomeButton } from "../assets/icons/icons";
import theme from "../theme";
import { useLocation } from "react-router-dom";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../locales";

const { md } = theme.screen;

// 정적 및 동적 경로 매핑
const getSiteMap = (t: any) => [
  //{ path: "/mobile-list", name: "농기계 상세조회" },
  { path: "/mobile-list", name: t.navigation.farmMachineryManagement },
  { path: "/detect-list", name: t.navigation.detectionHistory },
  { path: "/notice", name: t.navigation.notice },
  { path: "/notice-admin", name: t.notice.editBreadcrumb },
  { path: "/notice/:id", name: t.notice.detailBreadcrumb },
  //{ path: "/stastics", name: "감지내역 통계" },
  { path: "/stastics", name: t.navigation.statistics },
  //{ path: "/control", name: "사고 안전 관제" },
  { path: "/", name: t.navigation.accidentControl },
  { path: "/admin", name: t.navigation.userAccountManagement },
  { path: "/customer", name: t.navigation.ownerManagement },
  { path: "/nok", name: t.navigation.additionalRecipientManagement },
];

export const Breadcrumb = () => {
  const { t } = useI18n();
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const { width } = useWindowSize();
  const SITE_MAP = getSiteMap(t);

  const breadcrumbItems = pathnames.map((_, index) => {
    const fullPath = `/${pathnames.slice(0, index + 1).join("/")}`;
    // 경로 매칭 로직
    const match = SITE_MAP.find((item) => {
      if (item.path.includes(":")) {
        // 동적 경로 매칭 (예: /notice/:id)
        const dynamicBase = item.path.split("/:")[0];
        return fullPath.startsWith(dynamicBase);
      }
      return item.path === fullPath;
    });

    return match ? (
      <Link
        key={fullPath}
        underline="hover"
        color="inherit"
        href={fullPath}
        sx={{ textDecoration: "none" }}
      >
        {match.name}
      </Link>
    ) : (
      <Typography key={fullPath} color="textPrimary">
        {fullPath}
      </Typography>
    );
  });

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={Separator}
      sx={{
        paddingLeft: "8px",
        paddingBottom: width <= md ? "4px" : "8px",
        paddingTop: width <= md ? "4px" : "8px",
        color: theme.color.black,
        fontSize: width <= md ? "12px" : "15px",
      }}
    >
      <Link underline="hover" color="inherit" href="/">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          <HomeButton
            width={width <= md ? "10px" : "12px"}
            height={width <= md ? "10px" : "12px"}
            color={theme.color.black}
          />
          {t.navigation.home}
        </Box>
      </Link>
      {breadcrumbItems}
    </Breadcrumbs>
  );
};

const Separator = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6 11.5L10.125 7.75L6 4"
      stroke={theme.color.black}
      strokeLinecap="round"
    />
  </svg>
);
